import { Routes, Route, Navigate } from "react-router-dom";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import List from "./List/List";
import New from "./New/New";
import Edit from "./Edit/Edit";
import "./styles/ProjectAttachmentsMspa.css";

const PRIVILEGE = "projects.attachments";

export interface ProjectAttachmentsMspaProps {
  project_id: string;
}

const ProjectAttachmentsMspa = ({
  project_id,
}: ProjectAttachmentsMspaProps): JSX.Element => {
  const { hasPrivilege, privilegesLoading } = usePrivilegeCheck();

  if (privilegesLoading) return <ScopeStackSpinner />;

  if (!hasPrivilege(PRIVILEGE, ["view", "create", "manage"])) {
    return <div className="p-3">You do not have access to Attachments.</div>;
  }

  const canManage = hasPrivilege(PRIVILEGE, ["manage"]);

  return (
    <div className="projectAttachmentsMspa">
      <Routes>
        <Route
          index
          element={<List projectId={project_id} canManage={canManage} />}
        />
        {canManage && (
          <Route path="new" element={<New projectId={project_id} />} />
        )}
        {canManage && (
          <Route path=":id/edit" element={<Edit projectId={project_id} />} />
        )}
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </div>
  );
};

export default ProjectAttachmentsMspa;
